/** 广告落地页 AI 场景配置接口。 */
import type { LandingAiConfig, LandingAiScene } from '@novel-admin/shared';
import { apiRequest } from '~/api/client';
const pathFor = (scene: LandingAiScene) => `/api/v1/model-configurations/landing-html-${scene}`;
export const landingAiConfigApi = {
  get: (scene: LandingAiScene = 'desensitization') =>
    apiRequest<LandingAiConfig>({ method: 'GET', path: pathFor(scene) }),
  save: (input: LandingAiConfig, scene: LandingAiScene = 'desensitization') =>
    apiRequest<LandingAiConfig>({ method: 'PUT', path: pathFor(scene), body: input }),
};
